import { ADD_TAX_IDENTIFIER, SET_TAX_IDENTIFIERS } from './index.actions';
import { APP_INITIALIZATION } from '../core/base-actions';

export const namespace = 'taxIdentifiers';

export const reducer = (state = {}, action) => {
  switch (action.type) {
    case SET_TAX_IDENTIFIERS: {
      return {
        ...action.data,
      };
    }
    case APP_INITIALIZATION: {
      return {
        ...action?.initialData?.taxIdentifiers,
      };
    }
    case ADD_TAX_IDENTIFIER: {
      return {
        ...state,
        [action?.newTaxData?.taxIdentifierId]: action?.newTaxData,
      };
    }
    default: {
      return state;
    }
  }
};
